module.exports = __webpack_public_path__ + "static/media/eaitravelLogo.636d7e85.png";